<script lang="ts">
  import ProgressBar from '$shared/progress-bar/ProgressBar.svelte';

  export let percent: number = 0;
</script>

<div class="learning-history__progress-cell">
  <ProgressBar
    numerator={percent}
    denominator={100}
    color="yellow"
  />
  <span class="learning-history__progress-percent">
    {percent}%
  </span>
</div>

<style>
  .learning-history__progress-cell {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .learning-history__progress-percent {
    font-size: 0.875rem;
  }
</style>
